import createApi from 'api/createApi';
import qs from 'query-string';

	export const tags = {
		customerGet: 'mw/customerGet',
		customer__create__organization: 'mw/customer/create/organization',
		customer__create__individual: 'mw/customer/create/individual',
		customer__edit: 'mw/customer/edit',
		customer__edit__mult: 'mw/customer/edit/mult',
		customer__person: 'mw/customer/person',
		customer__person__link: 'mw/customer/person/link',
		customer__person__unlink: 'mw/customer/person/unlink',
		customer__person__issues__save: 'mw/customer/person/issues/save',
		customer__person__contact__save: 'mw/customer/person/contact/save',
		customer__person__contact__delete: 'mw/customer/person/contact/delete',
		customer__addresses: 'mw/customer/addresses',
		customer__addresses__export: 'mw/customer/addresses/export',
		customer__addresses_post: 'mw/customer/addresses_post',
		customer__services__type__list: 'mw/customer/services/type/list',
		customer__audit: 'mw/customer/audit',
		customer__audit__export: 'mw/customer/audit/export',
		customer__post__person__edit__mult: '/mw/customer/person/edit/mult',
	};

export const customerApi = createApi({
	reducerPath: 'mw/customerApi',
	tagTypes: Object.values(tags),

		endpoints: (builder) => ({
			customerGet: builder.mutation({
				query: (body) => ({
					method: 'GET',
				url: `/mw/customer?${qs.stringify(body)}`,
				}),
				providesTags: [tags.customerGet],
			}),
			customerCreateOrganization: builder.mutation({
				query: (body) => ({
					method: 'POST',
					url: '/mw/customer/create/organization',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__create__organization],
		}),
		customerCreateIndividual: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/create/individual',
				body,
				jsonType: true,
				}),
				providesTags: [tags.customer__create__individual],
			}),
			customerEdit: builder.mutation({
				query: (body) => ({
					method: 'POST',
					url: '/mw/customer/edit',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__edit],
		}),
		customerEditMult: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/edit/mult',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__edit__mult],
		}),
		customerPostPersonEditMult: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/person/edit/mult',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__post__person__edit__mult],
			invalidatesTags: [tags.customerGet, tags.customer__person],
		}),
		customerPersonGet: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/customer/person?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__person],
		}),
		customerPersonList: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/customer/person?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__person],
		}),
		customerPersonPost: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/person',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__person],
		}),
		customerPersonLink: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/person/link',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__person__link],
			invalidatesTags: [tags.customer__person],
		}),
		customerPersonUnlink: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/person/unlink',
				body,
				}),
				providesTags: [tags.customer__person__unlink],
				invalidatesTags: [tags.customer__person],
			}),
			customerPersonIssuesSave: builder.mutation({
				query: (body) => ({
					method: 'POST',
					url: '/mw/customer/person/issues/save',
				body,
				jsonType: true,
				}),
				providesTags: [tags.customer__person__issues__save],
			}),
			customerPersonContactSave: builder.mutation({
				query: (body) => ({
					method: 'POST',
					url: '/mw/customer/person/contact/save',
				body,
				jsonType: true,
			}),
			providesTags: [tags.customer__person__contact__save],
		}),
		customerPersonContactDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: `/mw/customer/person/contact/delete?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__person__contact__delete],
		}),
		customerAddressesGet: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/customer/addresses?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__addresses],
		}),
		customerAddressesGetOnce: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/customer/addresses?${qs.stringify(body)}`,
			}),
		}),
		customerAddressesExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: `/mw/customer/addresses/export?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__addresses__export],
		}),
		customerAddresses: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/addresses',
				body,
			}),
			providesTags: [tags.customer__addresses_post],
			invalidatesTags: [tags.customer__addresses],
		}),
			customerServicesTypeList: builder.mutation({
				query: (body) => ({
					method: 'GET',
					url: `/mw/customer/services/type/list?${qs.stringify(body)}`,
				}),
				providesTags: [tags.customer__services__type__list],
			}),
			customerAudit: builder.query({
				query: (body) => ({
					method: 'GET',
					url: `/mw/customer/audit?${qs.stringify(body)}`,
			}),
			providesTags: [tags.customer__audit],
		}),
		customerAuditExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/customer/audit/export',
				body,
			}),
			providesTags: [tags.customer__audit__export],
		}),
		customer__audit__export: 'mw/customer/audit/export',

	}),
});

export const {
	customerGet,
	customerCreateOrganization,
	customerCreateIndividual,
	customerEdit,
	customerEditMult,
	customerPersonGet,
	customerPersonList,
	customerPersonPost,
	customerPersonLink,
	customerPersonUnlink,
	customerPersonIssuesSave,
	customerPersonContactSave,
	customerPersonContactDelete,
	customerAddressesGet,
	customerAddressesGetOnce,
	customerAddressesExport,
	customerAddresses,
	customerServicesTypeList,
	customerAudit,
	customerAuditExport,
	customerPostPersonEditMult,
} = customerApi.endpoints;

export default customerApi;
